import { OrderData } from "@core/types";

type Params = {
  staticOrderDataEnabled: boolean;
  staticOrderData: OrderData | undefined;
  isLoading: boolean;
  isError: boolean;
};

export const shouldUseStaticOrderData = ({ staticOrderDataEnabled, staticOrderData, isLoading, isError }: Params) => {
  return Boolean(staticOrderDataEnabled && staticOrderData) && !isLoading && isError;
};
